import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Speciality } from 'src/app/models/speciality.model';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { ConfirmationDialogComponent } from '../../shared/index';
import { SpecialityFormComponent } from '../speciality-form/speciality-form.component';

@Component({
  selector: 'my-rep-speciality-management',
  templateUrl: './speciality-management.component.html',
  styleUrls: ['./speciality-management.component.scss'],
})
export class SpecialityManagementComponent implements OnInit {
  public isLoading: boolean = false;
  public specialityTableCols: string[] = ['name', 'actions'];
  public dataSource = new MatTableDataSource<Speciality>([]);

  public emptyScreenOptions = {
    title: 'No Specialities',
    imagePath: 'assets/images/organization-empty-screen.svg',
  };

  constructor(
    private dialog: MatDialog,
    private specialityService: SpecialityService,
    private snackbarService: SnackbarService
  ) {}

  public ngOnInit(): void {
    this.specialityService.specialitiesChanged.subscribe({
      next: (res) => {
        this.dataSource.data = res;
        this.isLoading = false;
      },
      error: (err) => {
        this.snackbarService.openSnackBar(err.error.message, 'error');
        this.isLoading = false;
      },
    });
    this.getSpecialities();
  }

  public getSpecialities() {
    this.isLoading = true;
    this.specialityService.getSpecialities().subscribe({
      error: (err) => {
        this.snackbarService.openSnackBar(err.error.message, 'error');
        this.isLoading = false;
      },
    });
  }

  public openSpecialityForm($event, speciality?: Speciality) {
    $event.stopPropagation();
    this.dialog.open(SpecialityFormComponent, {
      width: '660px',
      autoFocus: false,
      data: speciality || null,
    });
  }

  public openDeleteConfirmation($event, speciality: Speciality) {
    $event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40rem',
      autoFocus: false,
      data: {
        icon: 'close',
        title: 'Delete Speciality',
        message: `Are you sure you want to delete the speciality ${speciality.name}?`,
        isActionNeeded: true,
        actionText: 'Delete',
        cancelText: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.deleteSpeciality(speciality._id);
      }
    });
  }

  public deleteSpeciality(id: string) {
    this.specialityService.deleteSpeciality(id).subscribe({
      next: () => {
        this.dialog.open(ConfirmationDialogComponent, {
          width: '40rem',
          autoFocus: false,
          data: {
            icon: 'tick',
            title: 'Delete Successful',
            message:
              'Selected speciality has been deleted. This process can not be undone now',
          },
        });
      },
      error: (err) => {
        this.snackbarService.openSnackBar(err.error.message, 'error');
      },
    });
  }

  public trackByFn(index, speciality: Speciality) {
    return speciality._id;
  }
}
